<script setup>
import {ref} from "vue";
import startupsService from "@/services/startups.service";
import AiReport from "@/components/startups/AiReport.vue";
import ReportEditModal from "@/components/startups/ReportEditModal.vue";

const showModal = ref(false);
const id = ref(null);
const reportData = ref(null);
const failed = ref(null);
const reportEditModal = ref(null);
const generating = ref(false);

async function getData() {
    reportData.value = null;
    failed.value = null;

    const {data} = await startupsService.getAiReport(id.value);
    reportData.value = data['report'];
    failed.value = data['failed'];
}

async function generate() {
    generating.value = true;

    await startupsService.generateAiReport(id.value);

    generating.value = false;
    getData();
}

function showEditForm() {
    reportEditModal.value.open(id.value);
    showModal.value = false;
}

function open(startupId) {
    id.value = startupId;
    showModal.value = true;

    getData();
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <b-modal v-model="showModal" title="AI report" :hide-footer="failed === null || generating" modal-class="modal-w-xxl">
            <div v-if="failed !== null" class="mb-2">
                <AiReport v-if="reportData && !generating" :aiReportData="reportData" />

                <div v-else class="status" :class="{'error': failed}">
                    <template v-if="generating">
                        Generating...
                    </template>

                    <template v-else-if="failed">
                        AI report failed
                    </template>

                    <template v-else>
                        No AI report yet
                    </template>
                </div>
            </div>

            <template #modal-footer>
                <template v-if="!generating">
                    <button class="button" @click="generate">
                        <template v-if="reportData || failed">
                            Re-Generate
                        </template>

                        <template v-else>
                            Generate
                        </template>
                    </button>

                    <button class="button ml-2" @click="showEditForm">
                        <template v-if="reportData">
                            Edit
                        </template>

                        <template v-else>
                            Add
                        </template>
                    </button>
                </template>
            </template>
        </b-modal>

        <ReportEditModal
            ref="reportEditModal"
            @saved="getData"
            @closed="showModal = true"
        />
    </div>
</template>

<style scoped>
    .status {
        text-align: center;
        font-size: 18px;

        &.error {
            color: red;
        }
    }
</style>
